import { styled } from '@mui/system';

export const ModalHeaderText = styled('div')(({ theme }) => ({
    marginBottom: theme?.spacing(2) || '16px',
    fontWeight: 400,
    fontSize: '12px',
    color: theme?.palette?.text?.secondary || 'rgba(0, 0, 0, 0.6)',
    fontFamily: theme?.typography?.fontFamily || 'Roboto, Arial, sans-serif',
}));

export const PageSummaryContainer = styled('div')(({ theme }) => ({
    marginTop: theme?.spacing(2) || '16px',
    fontSize: '14px',
    fontWeight: 400,
    color: theme?.palette?.text?.secondary || 'rgba(0, 0, 0, 0.6)',
    fontFamily: theme?.typography?.fontFamily || 'Roboto, Arial, sans-serif',
    lineHeight: 1.5,
}));

export const DialogActionsContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme?.spacing(2) || '16px',
    gap: theme?.spacing(1) || '8px',
    width: '100%',
}));

export const StyledRadioGroup = styled('div')(({ theme }) => ({
    '& .MuiFormControlLabel-label': {
        fontSize: '14px',
        fontWeight: 400,
        color: theme?.palette?.text?.primary || 'rgba(0, 0, 0, 0.87)',
        fontFamily: theme?.typography?.fontFamily || 'Roboto, Arial, sans-serif',
    },
    '& .MuiRadio-root': {
        padding: theme?.spacing(1) || '8px',
    },
}));
